import {
  AfterViewInit,
  Component,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { saveAs } from 'file-saver';
import { ActivatedRoute, ParamMap } from '@angular/router';

import { TableComponent } from '@unilog/ng9-table';

import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-table-r',
  templateUrl: './table-r.component.html',
  styleUrls: ['./table-r.component.scss'],
})
export class TableRComponent implements OnInit {
  tableName;
  browseImages = null;
  table_D_Name;
  tableId_ColumnName;
  addedFile = null;
  commentaireOpened = false;
  selectedAlt = null;
  chatOpened = true;
  @ViewChild('tableComponent', { static: false })
  tableComponent: TableComponent;

  @ViewChild('tableComponent_D', { static: false })
  tableComponent_D: TableComponent;

  data: any;
  textVal: any = '';
  data_D: any;
  messages = [];
  constructor(
    private route: ActivatedRoute,

    public generalService: GeneralService
  ) {}
  ngOnInit(): void {
    this.route.paramMap.subscribe((res: ParamMap) => {
      let param = res.get('param');

      if (param) {
        let _param = param.valueOf();

        let splitted = _param.split(',');

        if (splitted.length > 1) {
          this.tableName = splitted[0];

          this.data = {
            listBtn: [],

            displayedColumnsBrut: {},

            dataSourceBrut: [],

            heightTable: 'calc(100vh - 64px)',

            colonnes: [],

            multipleSelect: false,

            api: this.generalService.api,

            showFilter: true,

            param: this.tableName,

            dataComposant: false,

            OnSelectRowOpenMenu: true,

            listBtnRowMenu: [],

            headerHeight: '24px',

            fontSizeTitleHeader: '16px',

            rowHeight: '30px',

            footerHeight: '50px',

            hasFooter: true,

            hasVirtualScrolling: true,

            headerBackgroundColor: 'white',

            headerTextColor: 'black',

            iconColorBeforeFilter: 'gray',

            iconColorAfterApplyFilter: 'green',

            iconColorBeforeSort: 'gray',

            headerIconsSize: '12px',
          };

          this.generalService
            .rechercheTable('recherche/tbdata?tablere=' + this.tableName)
            .subscribe((res: any) => {
              console.log(res);

              this.tableComponent.setDataSource(res);
            });
        }

        if (splitted.length == 3) {
          this.table_D_Name = splitted[1];

          this.tableId_ColumnName = splitted[2];

          this.data_D = {
            listBtn: [],

            displayedColumnsBrut: {},

            dataSourceBrut: [],

            heightTable: 'calc(100vh - 64px)',

            colonnes: [],

            multipleSelect: false,

            api: this.generalService.api,

            showFilter: true,

            param: this.table_D_Name,

            dataComposant: false,

            OnSelectRowOpenMenu: true,

            listBtnRowMenu: [],

            headerHeight: '24px',

            fontSizeTitleHeader: '16px',

            rowHeight: '30px',

            footerHeight: '50px',

            hasFooter: true,

            hasVirtualScrolling: true,

            headerBackgroundColor: 'white',

            headerTextColor: 'black',

            iconColorBeforeFilter: 'gray',

            iconColorAfterApplyFilter: 'green',

            iconColorBeforeSort: 'gray',

            headerIconsSize: '12px',
          };
        }
      }
    });
  }

  ngAfterViewInit() {}

  clickBtnHeat(event) {
    if (event.name == 'selectRow') {
      let id = event.row[this.tableId_ColumnName];
      if (this.selectedAlt == id) {
        this.selectedAlt = null;
        return;
      }
      this.selectedAlt = id;
      this.generalService
        .rechercheTable(this.table_D_Name, id)

        .subscribe((res: any) => {
          this.tableComponent_D.setDataSource(res);

          this.generalService
            .rechercheTable(
              'recherche/tbdata?tablere=ApiFilesNote&param=' +
                this.selectedAlt +
                ',' +
                this.tableName
            )
            .subscribe((res) => {
              setTimeout(() => {
                this.onScrollDivLoad();
              }, 300);
              this.messages = res;

              const reg = /(?:\.([^.]+))?$/;
              this.messages.forEach((message: any) => {
                const extestion = reg.exec(message.FilesStatic_Id)[1];
                message.isImage = [
                  'photos/300/300',
                  'jpeg',
                  'gif',
                  'png',
                  'apng',
                  'svg',
                  'bmp',
                  'bmp',
                  'ico',
                  'png',
                ].includes(extestion);
              });
            });
        });
    }
  }
  openChat(state) {
    this.commentaireOpened = state;
  }
  saveComment(e: Event) {
    e.preventDefault();
    this.generalService.getDS('FilesNote').subscribe(async (schema: any) => {
      schema.FilesNote[0].FilesNote_EntityId = this.selectedAlt;
      //schema.FilesNote[0].User_Id_Create = this.generalService.user.userName;
      schema.FilesNote[0].FilesNote_TableName = this.tableName;
      schema.FilesNote[0].FilesNote_Text = this.textVal;
      let url: any = '';
      if (this.addedFile) {
        url = await this.generalService
          .uploadFile2(this.addedFile, this.addedFile.type.replace('/', '.'))
          .toPromise();
        schema.FilesNote[0].FilesStatic_Id =
          this.generalService.getImgSrc(url.fileName) + '';
        schema.FilesNote[0].FilesStatic_Name = url.originalName;
      }

      this.addedFile = null;
      this.generalService.postDs(schema).subscribe(() => {
        this.textVal = '';
        this.generalService
          .rechercheTable(
            'recherche/tbdata?tablere=ApiFilesNote&param=' +
              this.selectedAlt +
              ',' +
              this.tableName
          )
          .subscribe((res) => {
            this.messages = res;
            setTimeout(() => {
              this.onScrollDivLoad();
            }, 500);
            const reg = /(?:\.([^.]+))?$/;
            this.messages.forEach((message: any) => {
              const extestion = reg.exec(message.FilesStatic_Id)[1];
              message.isImage = [
                'photos/300/300',
                'jpeg',
                'gif',
                'png',
                'apng',
                'svg',
                'bmp',
                'bmp',
                'ico',
                'png',
              ].includes(extestion);
            });
          });
      });
    });
  }
  showDate(id) {
    document.getElementById(id).classList.toggle('showDate');
    document.getElementById(id).classList.toggle('dontShowDate');
  }
  onScrollDivLoad() {
    document.getElementById('scrollDiv').scrollTop = 9000;
  }
  clickHiddenUpload() {
    document.getElementById('hiddenInput').click();
  }
  fileSelected(event) {
    this.addedFile = event.target.files[0];
  }
  download(url, name) {
    this.generalService.downlodeFile(url).subscribe((res) => {
      console.log(res);

      saveAs(res, name);
    });
  }
}
